import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import styled from '@emotion/styled';
import Truncate from 'react-truncate';
import moment from 'moment-timezone';

import {
  getSavedTimezone,
  timezoneCode,
} from 'ui_system/utilities/timezoneUtils';
import { t } from 'services/translation';
import PropsMixin from 'views/shared/tours/page/glance/mixin';
import ModalActionCreator from 'action_creators/modal';
import {
  Grid,
  Theme,
  CircleAvatar,
  Button,
  TruncatedGradient,
} from 'views/anyguide/messages/styles';
import Addons from './addons';
import CancellationPolicy from './cancellation_policy';

import { toISOTime } from 'views/plugins/booking_request/times';
import { formatDate } from 'views/plugins/booking_request/dates';

const ResourceGrid = styled(Grid)`
  margin-top: 40px;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    margin-top: 30px;
    grid-template-columns: '100%';
  }
`;

const ResourceModal = styled(Grid)`
  padding: 40px 80px 70px;
  /* max-height: ${document.body.clientHeight -
  100 -
  parseInt(document.body.clientHeight / 10)}px; */
  overflow: scroll;
  text-align: center;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding: 10px 20px 10px;
  }
`;

const ResourceAvatar = styled(CircleAvatar)`
  top: 0px;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    margin: 0px auto 30px;
  }
`;

const ResourceModalAvatar = styled(CircleAvatar)`
  margin: 20px auto;
  margin-bottom: 0px;
  top: -20px;
`;

const ResourceDetails = styled('div')`
  border-top: 1px solid #e6e6e6;
  margin-top: 40px;
`;

const ResourceName = styled('div')`
  font-size: 18px;
  margin-bottom: 15px;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    text-align: center;
  }
`;

const ResourceModalName = styled(ResourceName)`
  font-size: 21px;
  font-weight: 600;
`;

const ResourceBio = styled(Truncate)`
  position: relative;
  font-size: 14px;
`;

const ResourceModalBio = styled('div')`
  border-top: 1px solid #e6e6e6;
  padding-top: 20px;
  margin-top: 0px;
  font-size: 14px;
  text-align: left;
`;

const MoreButton = styled(Button)`
  margin: 30px auto;
  display: block;
  @media (max-width: ${Theme.mobile.phoneMaxWidth}px) {
    padding: 10px 0px;
  }
`;

const ResourceInfo = styled('div')`
  position: relative;
`;

const TourPageGlance = createReactClass({
  displayName: 'TourPage-Glance',
  mixins: [PropsMixin],
  propTypes: {
    transportation: PropTypes.string,
    availability: PropTypes.string.isRequired,
    iconClasses: PropTypes.object.isRequired,
    root_unit: PropTypes.object.isRequired,
    availabilityLink: PropTypes.node,
    addons: PropTypes.string,
    has_cancellation: PropTypes.bool,
    has_multiple_locations: PropTypes.bool,
  },

  getInitialState() {
    return { zoomResource: false, bioTruncated: true };
  },

  getDefaultProps() {
    return {
      addons: '',
      availabilityLink: null,
    };
  },

  shouldComponentUpdate() {
    return false;
  },

  _iconClass(name) {
    return `icon ${this.props.iconClasses[name]}`;
  },

  _bioTruncated(truncated) {
    if (truncated !== this.state.bioTruncated) {
      this.setState({
        bioTruncated: truncated,
      });
    }
  },

  _avatarInfo() {
    const { resource_name, resource_picture } = this.props;
    if (resource_picture) {
      return (
        <img alt="avatar" src={resource_picture} width="120" height="120" />
      );
    }
    const splitName = resource_name.split(' ');
    const in1 = splitName[0].charAt(0);
    const in2 = splitName.length > 1 ? splitName[1].charAt(0) : '';
    return (
      <span>
        {in1}
        {in2}
      </span>
    );
  },

  _showResourceModal() {
    const modalMaxHeight =
      window.innerHeight - parseInt(window.innerHeight / 10);
    const { resource_name, resource_bio } = this.props;
    ModalActionCreator.show({
      content: (
        <ResourceModal
          className="resource-modal"
          style={{ maxHeight: modalMaxHeight }}
        >
          <ResourceModalName className="resource-name">
            {resource_name}
          </ResourceModalName>
          <ResourceModalAvatar className="resource-avatar" size={120}>
            {this._avatarInfo()}
          </ResourceModalAvatar>
          <ResourceModalBio className="resource-bio" lines={10000}>
            {resource_bio}
          </ResourceModalBio>
        </ResourceModal>
      ),
      className: 'modal',
      settings: { closable: true },
      showIcon: true,
    });
  },

  _renderExtras() {
    let view = null;

    if (this.props.addons) {
      view = <Addons addons={this.props.addons} />;
    }
    return view;
  },

  _renderLanguages() {
    const { available_languages: availableLanguages } = this.props;

    if (
      !availableLanguages ||
      (availableLanguages.experience_languages == null &&
        availableLanguages.user_languages == null)
    ) {
      return null;
    }

    const {
      experience_languages: experienceLanguages,
      user_languages: userLanguages,
    } = availableLanguages;

    const hasExperienceLanguages =
      experienceLanguages != null && experienceLanguages.trim() !== '';

    const translatedLanguages = userLanguages
      ? userLanguages
          .split(',')
          .map((lang) => t(lang.trim()))
          .join(', ')
      : null;

    return (
      <div className="ui row">
        <div className="center aligned four wide column">
          <i
            className={this._iconClass('languages')}
            aria-hidden="true"
            alt="available languages"
          />
        </div>
        <div className="left aligned eight wide column">
          {hasExperienceLanguages
            ? experienceLanguages
            : `${t('OFFERED_IN')} ${translatedLanguages}`}
        </div>
      </div>
    );
  },

  _renderTransportation() {
    if (this.props.transportation == null) {
      return null;
    }
    return (
      <div className="ui row">
        <div className="center aligned four wide column">
          <i className={this._iconClass('transportation')} />
        </div>
        <div className="left aligned eight wide column">
          {this.props.transportation}
        </div>
      </div>
    );
  },

  _renderDuration() {
    // Duration is string coming from backend - eg '2 hours'
    let [length, lengthType] = this.props.duration_humanized.split(' ');
    const len = lengthType.length - 1;
    // singularize lengthType (pluralize logic handled in translation files, like es-ES.js)
    if (lengthType[len] === 's') lengthType = lengthType.slice(0, len);

    const lengthTypeTranslated = t(lengthType, false, {
      num: parseFloat(length),
    });

    return (
      <div className="left aligned eight wide column">
        {length} {lengthTypeTranslated}
      </div>
    );
  },

  _renderAvailability() {
    const {
      first_3_dates: datetimes,
      tour_timezone: tourTimezone,
      iso_time: isoTime,
      maxTimes,
      online,
    } = this.props;

    let savedTimezoneCode = null;
    let timezone = tourTimezone;
    if (online) {
      timezone = getSavedTimezone() || tourTimezone;
      if (timezone) savedTimezoneCode = timezoneCode(timezone);
    }

    const dates = {};
    datetimes.forEach(({ datetime, spots_left: spotsLeft }) => {
      const convertedDatetime = moment(datetime).tz(timezone);
      const date = convertedDatetime.format('YYYY-MM-DD');
      const time = convertedDatetime.format('h:mma');

      if (!dates[date]) dates[date] = [];
      dates[date].push(time);
    });

    const text = Object.keys(dates)
      .slice(0, 3)
      .map((date) => {
        let line = '';
        line += `${formatDate(date)} - `;

        const times = dates[date];
        times.slice(0, maxTimes).forEach((time, i) => {
          time = time.trim();
          if (this.props.iso_time) {
            time = toISOTime(time);
          }

          // Replace 'am' and 'pm' with translations using the t function
          if (time.endsWith('am')) {
            time = time.replace('am', t('AM'));
          } else if (time.endsWith('pm')) {
            time = time.replace('pm', t('PM'));
          }

          line += time;
          if (times.length > 1 && i < maxTimes - 1 && i !== times.length - 1) {
            line += ', ';
          }
        });

        if (times.length > maxTimes) {
          line += '...';
        }

        return (
          <div>
            {line} {savedTimezoneCode ? `(${savedTimezoneCode})` : ''}
          </div>
        );
      });

    return <div>{text}</div>;
  },

  render() {
    const {
      min_people: minPeople,
      max_people: maxPeople,
      root_unit,
      has_multiple_locations,
    } = this.props;

    const participantRange =
      minPeople === maxPeople ? maxPeople : `${minPeople} – ${maxPeople}`;
    const participantNoun =
      maxPeople === 1
        ? t(root_unit.noun_singular_translation)
        : t(root_unit.noun_plural_translation);

    return (
      <div className="TourPage-Glance tour-section">
        <h3 className="tour-section-title">{t('AT_A_GLANCE')}</h3>
        <div className="ui equal height grid">
          <div className="ui row" data-testid="experience-duration">
            <div className="center aligned four wide column">
              <i
                className={this._iconClass('duration')}
                aria-hidden="true"
                alt="experience duration"
              />
            </div>
            {this._renderDuration()}
          </div>
          <div className="ui row">
            <div className="center aligned four wide column">
              <i
                className={this._iconClass('people')}
                aria-hidden="true"
                alt="number of attendees"
              />
            </div>
            <div
              className="left aligned eight wide column"
              data-testid="participant-range"
            >
              {participantRange} {participantNoun} {t('PER_BOOKING')}
            </div>
          </div>
          {this._renderTransportation()}

          <div className="ui row">
            <div className="center aligned four wide column">
              <i
                className={this._iconClass('availability')}
                aria-hidden="true"
                alt="available date"
              />
            </div>
            <div className="left aligned eight wide column avail">
              {!has_multiple_locations ? this._renderAvailability() : null}
              {this.props.availabilityLink}
            </div>
          </div>

          {this._renderLanguages()}

          {this._renderExtras()}
          <div className="ui row">
            <div className="center aligned four wide column">
              {t('CANCELLATION')}
            </div>
            <div className="left aligned eight wide column">
              <CancellationPolicy
                description={this.props.cancellation_policy_description}
                name={this.props.cancellation_policy_name}
                has_cancellation={this.props.has_cancellation}
                zero_priced={this.props.zero_priced}
                is_mobile={Theme.mobile.isMobile}
              />
            </div>
          </div>
        </div>

        {this.props.has_resource && (
          <ResourceDetails>
            <h3 className="tour-section-title">
              {t('ABOUT_YOUR')}{' '}
              {this.props.resource_name_singular || t('GUIDE')}
            </h3>
            <ResourceGrid
              gridTemplateColumns={'100px 1fr'}
              responsiveTemplateColumns={'100%'}
            >
              <ResourceAvatar size={Theme.mobile.isMobile ? 92 : 72}>
                {this._avatarInfo()}
              </ResourceAvatar>
              <ResourceInfo>
                <ResourceName>{this.props.resource_name}</ResourceName>
                <ResourceBio
                  lines={4}
                  onTruncate={this._bioTruncated}
                  className="collapsed"
                  ellipsis={false}
                >
                  {this.props.resource_bio}
                </ResourceBio>
                {this.state.bioTruncated && (
                  <TruncatedGradient>&nbsp;</TruncatedGradient>
                )}
              </ResourceInfo>
            </ResourceGrid>
            {this.state.bioTruncated && (
              <MoreButton
                color={Theme.colors.blue}
                className="brand-border brand-color"
                onClick={() => this._showResourceModal()}
              >
                {t('READ_MORE')}
              </MoreButton>
            )}
          </ResourceDetails>
        )}
      </div>
    );
  },
});

export default TourPageGlance;
